import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "29",
  viewBox: "0 0 30 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M28.3011 14.4426C26.462 16.0893 25.2368 18.6095 24.4866 21.2759C24.0382 22.8698 23.7842 24.4366 23.6575 25.7578V28.2016H2.62891V25.573C2.62891 19.7661 7.33631 15.0587 13.1432 15.0587C16.3489 15.0587 19.2172 16.4954 21.1457 18.7577C22.0455 16.1592 23.461 13.4846 25.6725 11.5047L28.3011 14.4426ZM13.1432 0.601562C16.4096 0.601562 19.0575 3.24948 19.0575 6.51585C19.0575 9.78222 16.4096 12.4301 13.1432 12.4301C9.87682 12.4301 7.22891 9.78222 7.22891 6.51585C7.22891 3.24948 9.87682 0.601562 13.1432 0.601562Z",
  fill: "#121926",
  stroke: "#DCDEE3",
  "stroke-width": "1.2"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }